import { render, staticRenderFns } from "./FileTagUpload.vue?vue&type=template&id=feba8dea"
import script from "./FileTagUpload.vue?vue&type=script&lang=js"
export * from "./FileTagUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports